import { Link } from 'react-router-dom';
import { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'small';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.slug}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg mb-3 ${size === 'small' ? 'aspect-[3/4]' : 'aspect-[5/7]'}`}>
        <img
          src={comic.coverImage}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 bg-foreground-950/70 text-background-50 text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
            已完结
          </span>
        )}
        {comic.isNew && (
          <span className="absolute top-2 right-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
            NEW
          </span>
        )}
        {comic.isHot && !comic.isNew && (
          <span className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
            热门
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent h-16" />
        <div className="absolute bottom-2 left-2 right-2">
          <div className="flex items-center gap-1 text-background-50 text-xs">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span>{comic.rating}</span>
            <span className="mx-1 opacity-50">|</span>
            <i className="ri-eye-line text-xs"></i>
            <span>{comic.views > 10000 ? `${(comic.views / 10000).toFixed(0)}万` : comic.views}</span>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors truncate whitespace-nowrap">
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 truncate whitespace-nowrap">
        {comic.author} · {comic.category}
      </p>
      {size !== 'small' && comic.chapters.length > 0 && (
        <p className="text-xs text-primary-500 mt-1 truncate whitespace-nowrap">
          更新至 {comic.chapters[comic.chapters.length - 1].title}
        </p>
      )}
    </Link>
  );
}